import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const FormCheckbox = ({ input: { onChange, value }, label, disabled }: FormCheckboxProps) => (
  <FormControlLabel
    control={
      <Checkbox
        disabled={disabled}
        color="primary"
        checked={Boolean(value)}
        onChange={(_event, newValue) => onChange(newValue)}
      />
    }
    label={label}
  />
);

type FormCheckboxProps = {
  input: { value: string; onChange: (value: boolean) => void };
  label: JSX.Element;
  disabled: boolean;
};

export default FormCheckbox;
